import { pxToRem } from '../../../../utils';
export var chatMessageReadStatusVariables = function chatMessageReadStatusVariables(siteVars) {
  return {
    rightPoistion: pxToRem(-24),
    bottomPoistion: pxToRem(0)
  };
};
//# sourceMappingURL=chatMessageReadStatusVariables.js.map
